export default (value1, value2) => {

	const type1 = typeof value1;
	const type2 = typeof value2;

	if(type1 != type2){
		return false;
	}

	if(
		(value1 === null && value2 !== null) ||
		(value1 !== null && value2 === null)
	){
		return false;
	}

	if(
		(Array.isArray(value1) && !Array.isArray(value2)) ||
		(!Array.isArray(value1) && Array.isArray(value2))
	){
		return false;
	}

	return true;
}